import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { DashboardWidgetLookup, DashboardWidgetContent } from '@serengeti/serengeti-dashboard';
import { SchedulerService } from 'src/app/service/scheduler/service/scheduler.service';

@DashboardWidgetLookup('WizardServiceCalendarComponent')
@Component({
  selector: 'app-wizard-service-calendar',
  templateUrl: './wizard-service-calendar.component.html',
  styleUrls: ['./wizard-service-calendar.component.scss']
})
export class WizardServiceCalendarComponent implements OnInit, DashboardWidgetContent {

  schedules: any[];
  setting: any;

  constructor(
    private router: Router,
    private schedulerService: SchedulerService
  ) { }

  property(): boolean {
    return false;
  }

  configure(setting: any): void {
    this.setting = setting;
  }

  ngOnInit() {
    this.schedulerService.search('', 'createdDate', 'desc', 0, 100)
			.subscribe(resultPage => {
			this.schedules = resultPage.content;
		});
  }

  onScheduler(scheduler: any) {
		if (scheduler.taskHistoryId) {
			this.router.navigate(['/main', { outlets: { content: 'service/scheduler/detail/' + scheduler.id + '/' }}], { queryParams: { taskHistoryId: scheduler.taskHistoryId }});
		} else {
			this.router.navigate(['/main', { outlets: { content: 'service/scheduler/detail/' + scheduler.id + '/' }}]);
		}
	}
}
